module.exports = __webpack_public_path__ + "img/dog-wash-hero-46eea74.jpg";